







































import { Component, Vue, Watch } from 'vue-property-decorator'
import { RouteConfig } from 'vue-router'
import { PermissionModule } from '@/store/modules/permission'
import { TagsViewModule, TagView } from '@/store/modules/tags-view'
import ScrollPane from './ScrollPane.vue'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const path = require('path')

@Component({
  name: 'TagsView',
  components: {
    ScrollPane
  }
})
export default class extends Vue {
  private visible = false
  private top = 0
  private left = 0
  private selectedTag: TagView = {}
  private affixTags: TagView[] = []
  private sessiontag: any = [] // 缓存到本地的tag数组
  get visitedViews () {
    return TagsViewModule.visitedViews
  }

  get routes () {
    return PermissionModule.routes
  }

  get cachedViews () {
    const list = TagsViewModule.visitedViews
    return list.map(item => { return item.name })
  }

  @Watch('$route')
  private onRouteChange () {
    this.addTags()
    this.moveToCurrentTag()
  }

  @Watch('visible')
  private onVisibleChange (value: boolean) {
    if (value) {
      document.body.addEventListener('click', this.closeMenu)
    } else {
      document.body.removeEventListener('click', this.closeMenu)
    }
  }

  created () {
    if (sessionStorage.getItem('sessiontag')) {
      const str: any = sessionStorage.getItem('sessiontag')
      this.sessiontag = JSON.parse(str)
    }
  }

  mounted () {
    this.initTags()
    this.addTags()
    this.sessiontag = []
    sessionStorage.clear()
    window.addEventListener('beforeunload', this.refreshWindow)
  }

  activated () {
    this.initTags()
    this.addTags()
  }

  private refreshWindow () {
    sessionStorage.setItem('path', this.$route.path)
    sessionStorage.setItem('query', JSON.stringify(this.$route.query))
    sessionStorage.setItem('sessiontag', JSON.stringify(this.cachedViews))
  }

  private isActive (route: TagView) {
    return route.path === this.$route.path
  }

  private isAffix (tag: TagView) {
    return tag.meta && tag.meta.affix
  }

  private filterAffixTags (routes: RouteConfig[], basePath = '/') {
    let tags: TagView[] = []
    routes.forEach(route => {
      // if (route.meta && route.meta.affix) {
      //   const tagPath = path.resolve(basePath, route.path)
      //   tags.push({
      //     fullPath: tagPath,
      //     path: tagPath,
      //     name: route.name,
      //     meta: { ...route.meta }
      //   })
      // }
      if (route.meta && this.sessiontag.find((item: any) => item === route.name) && route.meta.menu) {
        const tagPath = path.resolve(basePath, route.path)
        tags.push({
          fullPath: tagPath,
          path: tagPath,
          name: route.name,
          meta: { ...route.meta }
        })
      }
      if (route.children) {
        const childTags = this.filterAffixTags(route.children, route.path)
        if (childTags.length >= 1) {
          tags = [...tags, ...childTags]
        }
      }
    })
    return tags
  }

  private initTags () {
    this.affixTags = this.filterAffixTags(this.routes)
    for (const tag of this.affixTags) {
      // Must have tag name because it just must have
      if (tag.name) {
        TagsViewModule.addVisitedView(tag)
      }
    }
  }

  private addTags () {
    const { name } = this.$route
    if (name) {
      TagsViewModule.addView(this.$route)
    }
    return false
  }

  private moveToCurrentTag () {
    const tags = this.$refs.tag as any[] // TODO: better typescript support for router-link
    this.$nextTick(() => {
      for (const tag of tags) {
        if ((tag.to as TagView).path === this.$route.path) {
          (this.$refs.scrollPane as ScrollPane).moveToTarget(tag as any)
          if ((tag.to as TagView).fullPath !== this.$route.fullPath) {
            TagsViewModule.updateVisitedView(this.$route)
          }
          break
        }
      }
    })
  }

  private refreshSelectedTag (view: TagView) {
    TagsViewModule.delCachedView(view)
    const { fullPath } = view
    this.$nextTick(() => {
      this.$router.replace({
        path: '/redirect' + fullPath
      })
    })
  }

  private closeSelectedTag (view: TagView) {
    TagsViewModule.delView(view)
    if (this.isActive(view)) {
      this.toLastView(TagsViewModule.visitedViews, view)
    }
  }

  private closeOthersTags () {
    if (this.selectedTag.fullPath !== this.$route.path && this.selectedTag.fullPath !== undefined) {
      this.$router.push(this.selectedTag.fullPath)
    }
    TagsViewModule.delOthersViews(this.selectedTag)
    this.moveToCurrentTag()
  }

  private closeAllTags (view: TagView) {
    TagsViewModule.delAllViews()
    if (this.affixTags.some(tag => tag.path === this.$route.path)) {
      return
    }
    this.toLastView(TagsViewModule.visitedViews, view)
  }

  private toLastView (visitedViews: TagView[], view: TagView) {
    const latestView = visitedViews.slice(-1)[0]
    if (latestView !== undefined && latestView.fullPath !== undefined) {
      this.$router.push(latestView.fullPath)
    } else {
      // Default redirect to the home page if there is no tags-view, adjust it if you want
      if (view.name === 'Dashboard') {
        // to reload home page
        this.$router.replace({ path: '/redirect' + view.fullPath })
      } else {
        this.$router.push('/')
      }
    }
  }

  private openMenu (tag: TagView, e: MouseEvent) {

    // const menuMinWidth = 105
    // const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
    // const offsetWidth = (this.$el as HTMLElement).offsetWidth // container width
    // const maxLeft = offsetWidth - menuMinWidth // left boundary
    // const left = e.clientX - offsetLeft + 15 // 15: margin right
    // if (left > maxLeft) {
    //   this.left = maxLeft
    // } else {
    //   this.left = left
    // }
    // this.top = e.clientY
    // this.visible = true
    // this.selectedTag = tag
  }

  private closeMenu () {
    this.visible = false
  }
}
